import { Component, OnInit } from '@angular/core';
import { Country } from '../country';
import { ActivatedRoute } from '@angular/router';
import { CountryService } from '../country.service';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { InputTextareaModule } from 'primeng/primeng';

@Component({
  selector: 'app-country-crud',
  templateUrl: './country-crud.component.html',
  styleUrls: ['./country-crud.component.css'],
  providers: [CountryService]
})
export class CountryCrudComponent implements OnInit {


	id: any = null;
	countries: Country;
	msgs: Message[] = [];
	loading: boolean = false;

 	button_caption: string ="Сохранить"
  	button_icon:string ="fa fa-save";

  constructor(
              private countryService: CountryService,
              private activatedRoute: ActivatedRoute,
              private location: Location
              ) {
  			 activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){
			this.loading=true;	 
   		  	this.countryService.getCountryById(this.id).subscribe(response=>{this.countries=response['data'];this.loading=false; console.log(this.countries);});	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }
   }

  ngOnInit() {

  			this.countries={
  			id: "",
			  name: "",
			  code: "",
			  sort: "",
			  available: true
  	    };
	}
  
  backClicked() {
        this.location.back();
  }

  crud(form: NgForm):void{
	this.loading=true;
   		  if(!this.id){
   		  		this.countryService.createCountry(form.value)
   		  		.subscribe((data) => {
						 this.msgs=[];
						 this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});
						 this.loading=false;
						},
					(error)=>{
						this.loading=false;
					});

   		  }else{
   		  	this.countryService.updateCountry(form.value,this.id)
   		  		.subscribe((data) => {
						 this.msgs=[];
						 this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});
						 this.loading=false;
						},
						(error)=>{
							this.loading=false;
						});
   		  }



  }

}


// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/countries/country-crud/country-crud.component.ts